import { useLayoutEffect } from 'react';
import type { RefObject } from 'react';

function useMobileNavigationAnimation(isOpen: boolean, isMobile: boolean, navigationRef: RefObject<HTMLDivElement>) {
  const transitionDurationMs = 300;

  useLayoutEffect(() => {
    const element = navigationRef.current;
    if (!element) return;

    if (isMobile) {
      element.style.height = '0px';
      element.style.transition = `height ${transitionDurationMs}ms ease`;

      if (isOpen) {
        element.classList.add('block');
        element.classList.remove('hidden');

        setTimeout(() => {
          element.style.height = `${element.scrollHeight}px`;
        }, 1);
      } else {
        element.classList.remove('hidden');
        element.style.height = '0px';

        setTimeout(() => {
          element.classList.add('hidden');
          element.classList.remove('block');
        }, transitionDurationMs);
      }
    } else {
      element.style.height = 'auto';
      element.style.transition = 'none';
      element.classList.add('block');
      element.classList.remove('hidden');
    }
  }, [isOpen, isMobile, navigationRef]);
}

export default useMobileNavigationAnimation;
